<template>
    <div class="flex flex-col tracking-wider w-full max-w-[1024px] h-fit p-8 border border-gray-100 lg:border-gray-300 rounded-md bg-gray-100 text-gray-700">
        <div class="flex justify-start items-center w-full">
            <slot name="header"></slot>
        </div>
        <div class="flex flex-col md:flex-row items-start justify-start w-full h-full">
            <div class="w-full min-w-[160px] md:w-[160px] h-full">
                <slot name="nav"></slot>
            </div>
            <div class="w-full h-full max-h-[calc(100vh-22rem)] md:pl-8 py-1 md:border-l border-gray-300 overflow-auto">
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script setup>
</script>